import {CbIdCodeLibelle} from "../../../val-composants-lib/src/public-api";

//Représente les paramètres des traitements
export class AFiTraitementParametres 
{
  //Création
  constructor () 
  {
    this.identifiantContexte = "";
    this.differe = false;
    this.identifiantsEntites = [];
  }

  //Identifiant du contexte
  public identifiantContexte: string;

  //Indique si traitement différé
  public differe: boolean;

  //Identifiants des entités
  public identifiantsEntites: number[];
}

//Représente un RG message
export class AItRgMessage 
{
  //Création
  constructor () 
  {
    this.typeMessage = -2;
    this.donneesMessage = new AItDonneesRgMessage ();
  }

  //Type de message
  public typeMessage: number;

  //Données du message
  public donneesMessage: AItDonneesRgMessage;
}

//Représente les données d’un RG message
export class AItDonneesRgMessage 
{
  //Création
  constructor () 
  {
    this.type = "";
    this.titre = "";
    this.bandeau = "";
    this.range = -1;
    this.niveau = -1;
    this.message = "";
    this.position = 0;
    this.boutons = -1;
    this.icone = 0;
  }

  //Type de données
  public type: string;

  //Titre
  public titre: string;

  //Bandau
  public bandeau: string;

  //Etendu
  public range: number;

  //Niveau
  public niveau: number;

  //Message
  public message: string;

  //Position
  public position: number;

  //Boutons
  public boutons: number;

  //Icone
  public icone: number;
}

//Représente les paramètres de création d’une RG réponse
export class AItCreerRgReponseParametres 
{
  //Création
  constructor () 
  {
    this.identifiantSession = "";
    this.typeMessage = -1;
  }

  //Identifiant de la session
  public identifiantSession: string;

  //Type de message
  public typeMessage: number;

  //Données de la reponse
  public donneeReponse: any;
}

//Représente les données du contrôle différé
export class AFiDonneesControleDiffere 
{
  //Label
  public label!: string;

  //Indique si visible
  public visible!: boolean;

  //Indique si en lecture seule
  public readOnly!: boolean;

  //Valeur
  public valeur!: boolean;
}

//Représente les données d’un identifiant lié à un code et un libellé
export class AFiIdentifiantCodeLibelle 
{
  //Identifiant
  public identifiant!: number | null;

  //Code
  public code!: string;

  //Libellé
  public libelle!: string;

  //Crée les données identifiant, code et libellé
  //  Paramètres
  //    afiIdentifiantCodeLibelle : Données identifiant code libellé
  //  Retourne
  //    Données identifiant, code et libellé
  public static CreerIdentifiantCodeLibelle (afiIdentifiantCodeLibelle: AFiIdentifiantCodeLibelle) : CbIdCodeLibelle 
  {
    let cbIdCodeLibelle: CbIdCodeLibelle;

    cbIdCodeLibelle = new CbIdCodeLibelle ();
    cbIdCodeLibelle.identifiant = afiIdentifiantCodeLibelle.identifiant || afiIdentifiantCodeLibelle.identifiant === 0  ? afiIdentifiantCodeLibelle.identifiant : null;

    if (afiIdentifiantCodeLibelle.identifiant)
      cbIdCodeLibelle.codeLibelle = `${afiIdentifiantCodeLibelle.code} - ${afiIdentifiantCodeLibelle.libelle}`;

    return cbIdCodeLibelle;
  }
}
